import React from 'react';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import cookie from 'react-cookies';

//-----------------------|| ROUTING RENDER ||-----------------------//

const Routes = () => {
    const token = cookie.load('token');
    // const token = localStorage.getItem('token');

    return token ? <MainRoutes /> : <AuthenticationRoutes />;
};

export default Routes;
